import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as CreditCardMdl from '../models/CreditCardModel';
import * as myCfg from '../AppConfig';
import { APIContainer, sawinFunc } from './sawinLib';
import * as ChargeRenewMdls from '../models/ServiceContractRenewChargeViewModel';
// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface RenewContractCharge { type: 'RENEWCONTRACT_CHARGERESULT', newState: ChargeRenewMdls.ServiceContractRenewChargeScreenStatus }
export interface RenewContractProcessing { type: 'RENEWCONTRACT_PROCESSING' }
export interface RenewContractError { type: 'RENEWCONTRACT_ERROR', error: string }
export interface RenewContractReset { type: 'RENEWCONTRACT_RESETINFO' }
export interface RenewContractSetInitialValues { type: 'RENEWCONTRACT_INITIALVALUES', contractNumber:string, amount:number }

export type KnownAction = RenewContractCharge | RenewContractProcessing | RenewContractError | RenewContractReset | RenewContractSetInitialValues;
 
export const actionCreators = {
    renewAndChargeCreditCard: (pCreditCardData: CreditCardMdl.CreditCardModel): AppThunkAction<KnownAction> => (dispatch, getState) => {

        const appState = getState();
        const sessionState = appState.sessionState;
        const contractToPayInfo = appState.serviceContractRenewChargeCardState;
        var ChargeInvoiceMdl: ChargeRenewMdls.ServiceContractRenewChargeViewModel = ChargeRenewMdls.ServiceContractRenewViewModelInitialState;

        ChargeInvoiceMdl = {
            ...ChargeInvoiceMdl, ...{
                creditCardInfo: pCreditCardData,
                companyCode: sessionState.SelectedAR.companyCode,
                entityCode: 'Customer',
                entityType: 'C',
                amountToCharge: contractToPayInfo.amount,
                arNum: sessionState.SelectedAR.id,
                //comments: '',
                //emailForReceipt: '',
                //error: '',
                oldContractNum: contractToPayInfo.contractNumber,
                serviceMasterNum: sessionState.SelectedSM.id
            }
        };

        //console.log(ChargeInvoiceMdl);

        dispatch({ type: 'RENEWCONTRACT_PROCESSING' });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/RenewContract',
            {
                method: 'POST',
                body: JSON.stringify(ChargeInvoiceMdl),
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {                
                try {                    
                    const data: CreditCardMdl.CreditCardARInvoice = container.data;                    
                    var creditCardResult: ChargeRenewMdls.ServiceContractRenewChargeScreenStatus = { ...ChargeRenewMdls.ServiceContractRenewChargeScreenStatusInitialLoad };
                    if (data.result != null && data.result.length > 0) {
                        creditCardResult.error = data.result;
                        creditCardResult.success = false;
                        creditCardResult.prossesingStatus = CreditCardMdl.CreditCardProcessStatus.Finished;
                    }
                    else {
                        if (data.autCode.length <= 0) {
                            creditCardResult.error = "Error processing Credit Card";
                            creditCardResult.success = false;
                            creditCardResult.prossesingStatus = CreditCardMdl.CreditCardProcessStatus.Finished;
                        } else {
                            creditCardResult.error = "";
                            creditCardResult.success = true;
                            creditCardResult.prossesingStatus = CreditCardMdl.CreditCardProcessStatus.Finished;
                        }
                    }

                    dispatch({ type: 'RENEWCONTRACT_CHARGERESULT', newState: creditCardResult });

                } catch {
                    console.log(`Catch ${container.errorInfo.message}`);
                    dispatch({
                        type: 'RENEWCONTRACT_ERROR', error: container.errorInfo.message
                    })
                }
            })
            .catch(function (err: Error) {                
                dispatch({                    
                    type: 'RENEWCONTRACT_ERROR', error: err.message
                })
            });
    }
};

export const reducer: Reducer<ChargeRenewMdls.ServiceContractRenewChargeScreenStatus> = (state: ChargeRenewMdls.ServiceContractRenewChargeScreenStatus | undefined, incomingAction: Action): ChargeRenewMdls.ServiceContractRenewChargeScreenStatus => {

    if (state === undefined) {
        return { ...ChargeRenewMdls.ServiceContractRenewChargeScreenStatusInitialLoad };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'RENEWCONTRACT_PROCESSING':
            return { ...state, prossesingStatus: CreditCardMdl.CreditCardProcessStatus.InProcesses, }
        case 'RENEWCONTRACT_CHARGERESULT':
            const chargeCreditCardAction = incomingAction as RenewContractCharge;
            return { ...chargeCreditCardAction.newState, prossesingStatus: CreditCardMdl.CreditCardProcessStatus.Finished}
        case 'RENEWCONTRACT_ERROR':
            const chargeCreditErrorAction = incomingAction as RenewContractError;
            return { ...state, prossesingStatus: CreditCardMdl.CreditCardProcessStatus.Finished, error: chargeCreditErrorAction.error, success:false }
        case 'RENEWCONTRACT_RESETINFO':
            return { ...ChargeRenewMdls.ServiceContractRenewChargeScreenStatusInitialLoad };
        case 'RENEWCONTRACT_INITIALVALUES':
            var initialAction = action as RenewContractSetInitialValues;
            return { ...ChargeRenewMdls.ServiceContractRenewChargeScreenStatusInitialLoad, ...initialAction };
        default:
            return state;
    }
}; 